import { useEffect } from "react";
import { AutocompleteInput, useChoicesContext } from "react-admin";
import { useFormContext } from "react-hook-form";

const CategorySelectOption = (props) => {
  const { allChoices, isLoading } = useChoicesContext();
  const { setValue } = useFormContext();

  useEffect(() => {
    if (!isLoading && allChoices[0]) {
      setValue(props.source, allChoices[0].id);
    }
  }, [isLoading, allChoices]);
  return <AutocompleteInput {...props} />;
};

export default CategorySelectOption;
